import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './utilisateurs.routes';

export class UtilisateursController {
  /*@ngInject*/
  constructor($http, $scope, $location, appConfig, Auth, Traduction) {
    var vm = this;
    vm.orderBy = "client";
    vm.reverseSort = false;
    vm.filters = [];
    vm.filters.role = 'all';
    $scope._ = _;
    $scope.Auth = Auth;

    $http.get('/api/sites').then(response => {
      vm.sites = response.data;
    });

    $http.get('/api/users/my/sites').then(response => {
      if(response.data.Sites.length == 0) {
        $http.get('/api/sites').then(response => {
          vm.sites = response.data;
        });
      }
      else vm.sites = response.data.Sites;
    });

    $http.get('/api/users').then(response => {
      vm.users = response.data;
    });

    vm.createUser = function(form){
      vm.action = 'save';
      vm.data = {};
      if(Auth.isAdminSync()) vm.data.role = 'user';
      else vm.data.role = 'guest';
      $("#addUser").modal('show');
      setTimeout(function(){
        $('#sitesSelect').selectpicker();
        $('#categoriesSelect').selectpicker();
      }, 10);
    }

    vm.editUser = function(user) {
      vm.action = 'edit';
      vm.data = angular.copy(user);
      vm.data.sites = _.map(user.Sites, '_id');
      vm.data.categories = _.map(user.Categories, '_id');
      $('#addUser').modal('show');
      setTimeout(function(){
        $('#sitesSelect').selectpicker();
        $('#categoriesSelect').selectpicker();
      }, 10);
    }

    vm.addUser = function(form){ 
      if(form.$valid) {
        vm.errors = undefined;
        $scope.clicked = true;
        if(vm.action == 'save') {
          Auth.createUser(vm.data).then(() => {
            $http.get('/api/users').then(response => {
              vm.users = response.data;
              $('#addUser').modal('hide');
              $scope.clicked = false;
              vm.data = {};
              vm.password = undefined;
            })
          }).catch(err => {
            vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
            $scope.clicked = false;
          });
        }
        if(vm.action == 'edit'){
          $http.patch(`/api/users/${vm.data._id}`, vm.data).then(response => {
            $http.get('/api/users').then(response => {
                vm.users = response.data;
                $('#addUser').modal('hide');
                $scope.clicked = false;
                vm.data = {};
                vm.password = undefined;
            })
          }).catch(err => {
            vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
            $scope.clicked = false;
          })
        }
      }
    }

    $scope.$watch('vm.data.sites' ,function(newV, oldV){
      vm.postes = [];
      _.forEach(newV, function(newSiteId){
        _.forEach(vm.sites,function(site){
          if(newSiteId == site._id) vm.postes.push(site.Postes);
        })
      })
      vm.postes = _.flatten(vm.postes);
      setTimeout(function(){
        $('.selectpicker').selectpicker('refresh');
      }, 10)
    })

    $scope.$watch('vm.data.role' ,function(newV, oldV){
      if(vm.data){
        setTimeout(function(){
          if(newV == "adminAperam") {
            // vm.data.sites = _(vm.data.sites).value();
            vm.data.categories = [];
          } else {
            vm.data.sites = [];
            vm.data.categories = [];
          }
          $('.selectpicker').selectpicker('refresh');
        }, 10)
      }
    })

    vm.filterUsers= function () {
      return _.filter(vm.users, function(user){
        var condition = (!vm.filters.name  || user.name.toUpperCase().includes(vm.filters.name) || user.name.toLowerCase().includes(vm.filters.name))
        && (!vm.filters.name  || user.prenom.toUpperCase().includes(vm.filters.name) || user.prenom.toLowerCase().includes(vm.filters.name))
        && (!vm.filters.email  || user.email.toUpperCase().includes(vm.filters.email) || user.email.toLowerCase().includes(vm.filters.email))
        && (!vm.filters.role  || vm.filters.role == 'all'  || user.role.includes(vm.filters.role))
      return condition;
      })
    }

    vm.clearFilters = function () {
      vm.filters = [];
      vm.filters.role = 'all';
    }

    vm.deleteUser = function(user) {
      vm.userToDelete = user;
      $('#deleteUser').modal('show');
    }

    vm.validateDelete = function(user) {
      $scope.clicked = true;
      $http.delete(`/api/users/${vm.userToDelete._id}`).then(function(){
        $http.get('/api/users').then(response => {
          vm.userToDelete = {};
          vm.users = response.data;
            $('#deleteUser').modal('hide');
            $scope.clicked = false;
          }).catch(function(){
            $('#deleteUser').modal('hide');
            $scope.clicked = false;
          });
      });
    }
  }
}

export default angular.module('aperamApp.utilisateurs', [uiRouter])
  .config(routing)
  .component('utilisateurs', {
    template: require('./utilisateurs.html'),
    controller: UtilisateursController,
    controllerAs:'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/utilisateurs/utilisateurs.component.js